import React, { Suspense, useEffect, useState, useRef } from 'react'
import WpAPI from '../../WpApi';
import { Redirect } from 'react-router';
import { CHOOSE_COLOR, CREATE_RESUME, DASHBOARD_LINK, FINAL_RESUME, HEADING_LINK, BREADCRUMB_LINKS, SITE_DOMAIN, APP_DOMAIN, POPUP_TYPES, COOKIE_DOMAIN, PAID_SERVICES, MEMBERSHIP, EDITOR_ALL_INONE_LINK, COVERLETTER_EXPERIENCE } from '../../constants/constants';
import Cookie from 'js-cookie';
import { connect, useDispatch } from 'react-redux';
import { 
  loadResume, 
  saveResume, 
  duplicateResume as duplicateResumeAction, 
  PREVIEW_RESUME,
  userCompletesSectionsDownloadsPrintsOrShares as userCompletesSectionsDownloadsPrintsOrSharesAction,
  setResumeFormat
} from '../../services/actions/actions';
import '../../assets/scss/app/blocks/dashboard.scss';
import downloadResume from '../../downloadResume';
import Resumes from '../resumetemplates/Resumes';
import PageLoader from '../common/PageLoader';
// import ArrowBtn from '../../images/btn-arrow.svg';
import { usePopup } from '../../context/PopupContext';
import SignUpPopup from '../user/SignUpPopup';
import { useHistory, useLocation } from 'react-router-dom';
import Splash from '../common/Splash';
// import AiBanner from './common/AiBanner';
import { getDateForDisplay, removeBodyScroll } from '../../helper';
import { useUser } from '../../context/UserContext';
import { getResumeName } from '../../helper';
import { prevent } from '../common/Prevent';
import { NoResumeFound } from './NoResumeFound';

const ResumesListing = (props) => {
  const entityName = "Resume";
  const entityType = "resume"
  const reactHistory = useHistory();
  const confirmbox = usePopup();
  const location = useLocation();
  const [entities, setEntities] = useState('')
  const [currentEntity, setCurrentEntity] = useState('');
  const [spinner, setSpinner] = useState(false)
  const [createAction, setCreateAction] = useState(false)
  const [editAction, setEditAction] = useState('')
  const [singleEntity, setSingleEntity] = useState('')
  const [renameEntity, setRenameEntityBox] = useState(false)
  const [newName, setNewName] = useState('')
  const [error, setError] = useState([])
  const [buttonList, setButtonList] = useState('');
  const entityRef = useRef("");
  const [entityLink, setEntityLink] = useState(false);
  const [showLoginPopUp, setShowLoginPopUp] = useState(false);
  const [singleItemHeight, setSingleItemHeight] = useState('100%');
  const [singleItemWidth, setSingleItemWidth] = useState("auto");
  const [loader, setLoader] = useState({download: false, save: false, share: false});
  const [showLoader, setShowLoader] = useState(true)
  // const [showAiBanner, setShowAiBanner] = useState(true);
  const errorStyle = { color: 'red', fontSize: '10px' }
  const {
    checkMembership,
    plan,
    user
  } = useUser();

  const mounted = useRef(false);

  useEffect(() => {
      mounted.current = true;
      return () => {
          mounted.current = false;
      };
  }, []);

  //set dashboard_tab
  useEffect(() => {
    Cookie.set('dashboard_tab', 'resume', {domain: COOKIE_DOMAIN, path: "/"});
  }, []);

  // Manage button list click on short size of template

  const dispatch = useDispatch()
  let entityNames = [];

  // Set Reumes Scaling Logic
  const scalingAreaElements = useRef([]);
  const observer = useRef(null);

  const changeScale = () => {
    const elements = scalingAreaElements.current;

    if (elements.length > 0) {
      for (let i = 0; i < elements.length; i++) {
        const width = document.getElementsByClassName('resume-container')[0].offsetWidth;        
        elements[i].style.transform = `scale(${width / 641})`;
      }
    }
  };

  useEffect(() => {
    const observerCallback = (mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          scalingAreaElements.current = Array.from(
            document.querySelectorAll('.single-template .scaling-area')
          );
          changeScale();
        }
      }
    };

    const options = { childList: true, subtree: true };
    observer.current = new MutationObserver(observerCallback);
    observer.current.observe(document.body, options);

    return () => {
      if (observer.current) {
        observer.current.disconnect();
      }
    };
  }, []);

  useEffect(() => {
    scalingAreaElements.current = Array.from(
      document.querySelectorAll('.single-template .scaling-area')
    );
    changeScale();
    // Set Scaling when device orientation changes
    let portrait = window.matchMedia("(orientation: portrait)");
    portrait.addEventListener("change", function(e) {
        if(e.matches) {
            // Portrait mode
            changeScale();
        } else {
          // Landscape Mode
          changeScale();
        }
    })
  }, []);

  const editEntity = (key, editorType) => {
    dispatch(loadResume(key)).then(res => {
        const tabs = res.resume.enabled_tabs;
        let edit_action = (
          tabs.length > 1 //User should move ahead of first section
            ? (
              //Incompleted resume should land to ALLINONE
              (WpAPI.isLoggedIn() && plan == 'pro' && tabs.indexOf('completed') == -1) ? EDITOR_ALL_INONE_LINK : FINAL_RESUME
              ) : HEADING_LINK
        );
        if(mounted.current) setEditAction(edit_action);
    })
  }
    
  const deleteEntity = key => {
    WpAPI.deleteResume(key)
    let r = { ...entities }
    delete r[key]
    setEntities(r);
    props.setResumeCount(Object.keys(r).length);
    setTimeout(() => {
      if (!Object.keys(r).length) {
        let loader = document.querySelector('.page-loader');
        if (loader != null) {
          loader.style.display = 'none';
        }
      }
    }, 200);
  }

  const duplicateEntity = key => {
    dispatch(duplicateResumeAction(key, '', 'list')).then(res => {
      let entities = JSON.parse(JSON.stringify(res))
      setEntities(entities);  
    })
  }  
  const onClickOutside = (e) => {
    if (e.target.classList.value != 'single-template')
      setButtonList('');
  }
  useEffect(() => {
    const handleClickOutside = (e) => {
      // If entity has been deleted then current reference is not found. So, we have to add a null condition.
      if ((entityRef.current && !entityRef.current.contains(e.target)) || entityRef.current == null) {
        onClickOutside && onClickOutside(e);
      }
    };
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [onClickOutside]);

  useEffect(() => {
    confirmbox.configurePopup(POPUP_TYPES);
  }, []);

  useEffect(() => {
    if (entities === '') { // Only for first time or till no entity is set
      WpAPI.loadResumesInDashboard((res) => {
        setEntities(res); 
        props.setResumeCount(Object.keys(res || {}).length); // Ensure `res` is not null
        setShowLoader(false);
      });
  
      // setTimeout(() => {
      //   if (!Object.keys(entities).length) {
      //     let loader = document.querySelector('.page-loader');
      //     if (loader != null) {
      //       loader.style.display = 'none';
      //     }
      //   }
      // }, 1500);
    }

    if (currentEntity === '') {
      let cr = WpAPI.getCurrentResume();
      setCurrentEntity(cr);
    }
  }, []);

  if (createAction) {
    history.pushState(null, DASHBOARD_LINK);
    return <Redirect to={CHOOSE_COLOR} />
  }
  if (editAction.length) {
    history.pushState(null, DASHBOARD_LINK);
    return <Redirect to={editAction} />
  }

  const dashboardEntities = Object.keys(entities || {}).sort((x, y) => {
    if (entities[x].hasOwnProperty('modified_date') && entities[y].hasOwnProperty('modified_date')) {
      return (new Date(entities[x].modified_date)).getTime() - (new Date(entities[y].modified_date)).getTime()
    } else if (entities[x].hasOwnProperty('modified_date') && !entities[y].hasOwnProperty('modified_date')) {
      return (new Date(entities[x].modified_date)).getTime() - (new Date('1947-01-01')).getTime()
    } else if (!entities[x].hasOwnProperty('modified_date') && entities[y].hasOwnProperty('modified_date')) {
      return (new Date('1947-01-01')).getTime() - (new Date(entities[y].modified_date)).getTime()
    } else if (entities[x].hasOwnProperty('created_date') && entities[y].hasOwnProperty('created_date')) {
      return (new Date(entities[x].created_date)).getTime() - (new Date(entities[y].created_date)).getTime()
    }
  }).reverse();

  const checkEntityCount = (entities) => {
    return Object.keys(entities).length;
  }

  const downloadHandle = (entity, type) => {
    setSpinner(true);
    downloadResume(entity, () => {
      setSpinner(false);
      gaTrack('RT App', 'Dashboard', `Download ${entityName}`);
      ga4Track(`app_dashboard_download_${entityType}`, 'RT App', `Download ${entityName}`);
    }, 'pdf');
  }

  const downloadHandler = (key, downloadFormat) => {
    downloadResume({[entityType]: {...entities[key], id: key}, user: props.user}, user, () => { 
      confirmbox.close('download');
      confirmbox.show('askfor_trustpilot_review', null, () => {
        window.open( `https://www.trustpilot.com/review/resumetemplates.com`, '_blank');
    });
    }, downloadFormat, {type: entityType, name: entityName });
  }

  const userCompletesSectionsDownloadsPrintsOrShares = (entity) => {
    dispatch(userCompletesSectionsDownloadsPrintsOrSharesAction({...entity}, 'list')).then(res => {
      if(res.completed){
        const ec = (PAID_SERVICES && plan == 'pro' ? 'app_editor_finalizations' : 'app_editor_finalizations_free');
        const el = (
            PAID_SERVICES && plan == 'pro' 
            ? 'User completes sections: Downloads, Prints or Shares' 
            : 'Free user completes sections: tries to download, print, share'
        );
        ga4Track(ec, 'RT App', el)
      }
    })
  }

  const download = (params) => {
    localStorage.setItem('clickAction', 'download');
    if(WpAPI.isLoggedIn()){
        localStorage.setItem(`${entityName}Name`, params.rname);
        confirmbox.show('download', null, (popupParams) => {
            downloadHandler(params.key, popupParams.downloadFormat); 
            userCompletesSectionsDownloadsPrintsOrShares(params.resume); 
            gaTrack('RT App', 'Dashboard', `Download ${entityName}`)
            ga4Track(`app_dashboard_download_${entityType}`, 'RT App', `Download ${entityName}`);
        }, {plan: plan, entity:{type: entityType, name: entityName }, referrer:'dashboard'});
      ga4Track(`app_my_${entityType}s_download`, 'RT App', `My ${entityName}s: Download`);
    }else{
      setShowLoginPopUp(true);
      Cookie.set('redirect_to', location.pathname, { domain: COOKIE_DOMAIN, path: "/" });
    }
  }

  const share = (params) => {
    if(WpAPI.isLoggedIn()){
      if(PAID_SERVICES){
        if(plan == 'pro'){
          confirmbox.show('share', null, () => {
            gaTrack('RT App', 'Dashboard', `Share ${entityName}`)
            ga4Track(`app_dashboard_share_${entityType}`, 'RT App', `Share ${entityName}`);
          }, {[entityType]: {...params.resume, id: params.key}, user: props.user, type: 'list', entity:{type: entityType, name: entityName }})
        }else{
          reactHistory.push(MEMBERSHIP)
        }
      }else{
          confirmbox.show('share', null, () => {
            gaTrack('RT App', 'Dashboard', `Share ${entityName}`)
            ga4Track(`app_dashboard_share_${entityType}`, 'RT App', `Share ${entityName}`);
          }, {[entityType]: {...params.resume, id: key}, user: props.user, type: 'list', entity:{type: entityType, name: entityName }})
      }
      ga4Track(`app_my_${entityType}s_share_a_link`, 'RT App', `My ${entityName}s: Share a Link`);
      userCompletesSectionsDownloadsPrintsOrShares(params.resume);
    }else{
      setShowLoginPopUp(true);
      Cookie.set('redirect_to', location.pathname, { domain: COOKIE_DOMAIN, path: "/" });
    }
  }

  const checkMembershipAction = (callback = false, params = false) => {
    if(typeof callback == 'function' && mounted.current) setLoader({...loader, [callback.name]: true});
    checkMembership(() => {
      if(typeof callback == 'function'){
        callback(params);
        if(mounted.current) setLoader({...loader, [callback.name]: false});
      }
    });
  }

  return (
    <>
     {showLoader ? <PageLoader /> :   ( dashboardEntities.length ? 
      <div className="dashboard-container">
        <Splash />
        <div className="block">
        {spinner ? (
          <div className="spinner spinner-dashboard">
            <img
              className="loader-img"
              src="{`${APP_DOMAIN}/assets/images/spinner.svg`}"
              alt="loader"
            />
          </div>
        ) : (
          ""
        )}
          {/* <h1>My {entityName}s</h1> */}
          {/* {(Cookie.get('rbuser', {domain: COOKIE_DOMAIN, path: "/"}) && props.user !== null) 
            && <p>Welcome back{props.user.firstname != '' ? `, ${props.user.firstname} ${props.user.lastname}` : ''}!</p>
          } */}
          <div className="small-size-templates">
            <ul>
              {/* Dont show Create untill it loads the result */}
             {dashboardEntities.length > 0 &&  <li className="create-new" onClick={() => {
                  gaTrack('RT App', 'Dashboard', `Create a New ${entityName}`);
                  ga4Track('app_dashboard_create_button', 'RT App', `Create a New ${entityName}`);
                setCreateAction(true);
              }}>
                <span>+ Create New {entityName}</span>
              </li>}
              {/* showLoader will hold the block till the ajax call completed */}
              {dashboardEntities.map((key, index) => {
                    let entity = entities[key];
                        const rname = getResumeName(entity);
                        entityNames[key] = rname
                        return (
                          <li 
                            className="single-template" 
                            key={key} 
                            ref={entityRef} 
                            onClick={() => editEntity(key, entity.active_editor)}
                          >
                          <div className="resume-actions">
                            <div className="toggle-action-list" onClick={prevent(() => { if(mounted.current) setButtonList(key) })}><span></span><span></span><span></span></div>
                            <div className={buttonList == key ? 'buttons-list active-button-list' : 'buttons-list'}>
                                <ul>
                                  <li onClick={prevent(() => {
                                    editEntity(key, entity.active_editor);
                                    gaTrack('RT App', 'Dashboard', `Edit ${entityName} Icon`)
                                    ga4Track(`app_dashboard_edit_${entityType}_icon`, 'RT App', `Edit ${entityName} Icon`);
                                  })}><span className="icon-edit-copy"></span> Edit {entityName}</li>
                                  <li onClick={prevent(() => checkMembershipAction(download, {[entityType]: entity, key: key, rname: rname}))}>
                                    <span className="icon-file-text"></span> {loader.download ? 'Loading...' : 'Download'}
                                  </li>
                                    {(PAID_SERVICES && plan == 'pro') && <li onClick={prevent(() => { checkMembershipAction(share, {[entityType]: entity, key: key}) })}><span className="icon-link"></span> {loader.share ? 'Loading...' : 'Share a Link'}</li>}
                                  <li onClick={prevent(() => {
                                    duplicateEntity(key);
                                    gaTrack('RT App', 'Dashboard', `Duplicate ${entityName}`)
                                    ga4Track(`app_dashboard_duplicate_${entityType}`, 'RT App', `Duplicate ${entityName}`);
                                  })}><span className="icon-copy"></span> Duplicate</li>
                                  <li onClick={prevent(() => {
                                      confirmbox.show('delete', null, () => {
                                        deleteEntity(key);
                                        gaTrack('RT App', 'Dashboard', `Delete ${entityName}`);
                                        ga4Track(`app_dashboard_delete_${entityType}`, 'RT App', `Delete ${entityName}`);
                                      })
                                  })}><span className="icon-trash"></span> Delete {entityName}</li>
                                  {(user?.capabilities?.administrator || user?.capabilities?.editor || user?.capabilities?.author) && <li onClick={prevent(() => { setEditAction("/admin-options/"+key) })}> Admin Options </li>}
                                </ul>
                            </div>
                          </div>
                          <div className="resume-block">
                            <div className="static-view"
                              onClick={prevent(() => {
                                editEntity(key, entity.active_editor);
                                gaTrack('RT App', 'Dashboard', `Edit ${entityName}`);
                                ga4Track(`app_dashboard_edit_${entityType}`, 'RT App', `Edit ${entityName}`);
                              })} role="button">
                              <Resumes data={entity} />
                            </div>
                          </div>
                          <div className="short-desc">
                              <div className="details">
                                <i title={rname}>{rname}</i>
                                  <span className="edit-date">Last Modified {getDateForDisplay(entity.modified_date)}</span>
                              </div>
                            </div>
                          </li>
                        );
                }) }
            </ul>
          </div>
          {/* {showAiBanner ? <AiBanner setShowAiBanner={setShowAiBanner} showAiBanner={showAiBanner} /> : ''} */}
        </div>
      </div> : <NoResumeFound /> ) }
      {showLoginPopUp ? <SignUpPopup setShowLoginPopUp={(c) => { setShowLoginPopUp(c) }} setEntities={r => setEntities(r)} /> : ''}
    </>
  );
  
}

export default ResumesListing;